import type Pageable from 'models/Pageable';
import type { ArSummaryVO, ArSummaryVOModel } from 'models/vo/ArSummaryVO';
import { formattingToArSummaryVOModel } from 'models/vo/ArSummaryVO';
import type { LastArPhaseVO, LastArPhaseVOModel } from 'models/vo/LastArPhaseVO';
import { formattingToLastArPhaseVOModel } from 'models/vo/LastArPhaseVO';
import http from 'utils/http';
import API_AC from 'utils/http/api/anchor';

import type { AnchorArPhaseApproveRequest, AnchorArRegisterRequest, AnchorArSummariesListRequest } from './request';

// ar summary list
export async function requestAnchorArSummaryList(
  pageNumber: number,
  rowCount: number,
  searchValue: AnchorArSummariesListRequest,
): Promise<Pageable<ArSummaryVOModel[]>> {
  const response = await http.get<Pageable<ArSummaryVO[]>>({
    url: API_AC.AR_SUMMARIES.AR_SUMMARIES,
    data: {
      pageNumber,
      rowCount,
      ...searchValue,
    },
  });
  const arSummaryList: ArSummaryVOModel[] = response.content.map((data: ArSummaryVO) =>
    formattingToArSummaryVOModel(data),
  );
  const arSummaryPage: Pageable<ArSummaryVOModel[]> = {
    ...response,
    content: arSummaryList,
  };

  return arSummaryPage;
}

// 수기 AR 등록
export async function requestAnchorArRegister(data: AnchorArRegisterRequest): Promise<void> {
  await http.post<null>({
    url: API_AC.AR_SUMMARIES.AR_SUMMARIES,
    data,
  });
}

// bulkUpload 시 유효성 검사
export async function requestAnchorArValidate(data: AnchorArRegisterRequest): Promise<void> {
  await http.post<null>({
    url: API_AC.AR_SUMMARIES.AR_SUMMARY_VALIDATE,
    data,
  });
}

// AR 결재 요약 단건 조회
export async function requestAnchorArSummaryDetail(arSummaryId: number): Promise<ArSummaryVOModel> {
  const response = await http.get<ArSummaryVO>({
    url: API_AC.AR_SUMMARIES.AR_SUMMARY_DETAIL(arSummaryId),
  });

  return formattingToArSummaryVOModel(response);
}

// 마지막 단계 송장 결재 조회
export async function requestAnchorArSummaryLastPhase(arSummaryId: number): Promise<LastArPhaseVOModel> {
  const response = await http.get<LastArPhaseVO>({
    url: API_AC.AR_SUMMARIES.AR_SUMMARY_LAST_PHASE(arSummaryId),
  });

  return formattingToLastArPhaseVOModel(response);
}

// ar 결재 승인
export async function requestAnchorApproveArPhase(data: AnchorArPhaseApproveRequest): Promise<void> {
  await http.put<null>({
    url: API_AC.AR_SUMMARIES.AR_SUMMARY_APPROVE,
    data,
  });
}

// ar 거절
export async function requestAnchorRejectArRegistration(arSummaryId: number, reason?: string) {
  const response = await http.put({
    url: API_AC.AR_SUMMARIES.AR_SUMMARY_REJECT,
    data: {
      arSummaryId: arSummaryId,
      reason: reason,
    },
  });

  return response;
}
